module.exports = __webpack_public_path__ + "static/media/206.eaba4eeb.png";